<template>
  <v-row justify="center">
    <v-dialog v-model="show" persistent max-width="515">
      <v-card flat>
        <v-toolbar flat dense color="primaryLight1">
          <v-icon left>mdi-calendar</v-icon>
          <v-tooltip bottom content-class="tipMeetingName" max-width="600">
            <template v-slot:activator="{ on, attrs }">
              <v-toolbar-title v-bind="attrs" v-on="on">
                <span>{{ meetingFormData.Subject || "not found" }}</span>
              </v-toolbar-title>
            </template>
            <span
              style="word-break: break-word"
              v-text="meetingFormData.Subject"
            ></span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <CloseIcon @click="onClose" />
        </v-toolbar>

        <v-card-text>
          <v-row>
            <v-col cols="4" class="pa-0 align-right">
              <v-list-item dense>
                <v-list-item-icon class="mr-2">
                  <v-icon color="neutralGray">mdi-calendar-clock</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title
                    >{{ $t("lblSchedule") }}:</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="8" class="contentValue">
              {{ getTimeDetails(meetingFormData) }}
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4" class="pa-0 align-right">
              <v-list-item dense>
                <v-list-item-icon class="mr-2">
                  <v-icon color="neutralGray">mdi-map-marker-radius</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title
                    >{{ $t("agenda.lblMeetingLocation") }}:</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="8" class="contentValue">
              {{ meetingFormData.Location }}
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4" class="pa-0 align-right">
              <v-list-item dense>
                <v-list-item-icon class="mr-2">
                  <v-icon color="neutralGray">mdi-calendar-question</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title
                    >{{ $t("agenda.lblMeetingType") }}:</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="8" class="contentValue">
              {{ meetingFormData.Description }}
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4" class="pa-0 align-right">
              <v-list-item dense>
                <v-list-item-icon class="mr-2">
                  <v-icon color="neutralGray">mdi-handshake-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title
                    >{{ $t("agenda.lblResType") }}:</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="8" class="contentValue">
              {{ getResolutionType(meetingFormData.resolutionType) }}
            </v-col>
          </v-row></v-card-text
        ><v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <a-btn
            v-if="meetingPermission('ViewMeeting')"
            small
            @click="openMeetingDayPage(meetingFormData.id)"
            color="primaryDark"
            class="mr-0"
          >
            {{ $t("btnView") }}</a-btn
          >
          <div v-if="meetingPermission('UpdateMeeting')">
            <edit-recurrence-button
              v-if="isRecurrenceMeeting"
              @onEdit="onEditSelection"
            ></edit-recurrence-button>
            <a-btn
              v-else
              small
              @click="onEditMeeting()"
              color="primaryDark"
              class="ml-3"
            >
              {{ $t("btnEdit") }}</a-btn
            >
          </div>
          <div v-if="meetingPermission('UpdateMeeting')">
            <a-btn
              small
              @click="onCopyMeeting()"
              color="primaryDark"
              class="ml-3"
            >
              {{ $t("poll.tipCopy") }}</a-btn
            >
          </div>
          <div v-if="meetingPermission('DeleteMeeting')">
            <delete-recurrence-button
              v-if="isRecurrenceMeeting"
              @onDelete="onDeleteSelection"
            >
            </delete-recurrence-button>
            <a-btn
              v-else
              small
              @click="onDeleteMeeting(meetingFormData)"
              color="primaryDark"
              class="ml-3"
            >
              {{ $t("btnDelete") }}</a-btn
            >
          </div>
          <confirm-dialog ref="confirm" />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { Internationalization } from "@syncfusion/ej2-base";
import Meeting from "../meeting.vue";
import { mapActions, mapGetters } from "vuex";
import ConfirmDialog from "../../ConfirmDialog.vue";
import customFunctions from "@/codeFiles/taskHelper.js";
import Loader from "../../Loader.vue";
import EditRecurrenceButton from "../recurrence/EditRecurrenceButton.vue";
import DeleteRecurrenceButton from "../recurrence/DeleteRecurrenceButton.vue";
export default {
  components: {
    Meeting,
    ConfirmDialog,
    Loader,
    EditRecurrenceButton,
    DeleteRecurrenceButton,
  },
  name: "QuickInfoDialog",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    meetingFormData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      //   data: {},
      isSeriesEdit: false,
      isSeriesDelete: false,
      intl: new Internationalization(),
      dialogMeeting: false,
    };
  },
  computed: {
    ...mapGetters({
      resolutionTypes: "meeting/getResolutionTypesList",
    }),
    LoaderText() {
      return this.$t("LoaderText");
    },
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || false);
      },
    },
    headerColor() {
      return this.meetingFormData.meetingType.color || "#F5CBA7";
    },
    tenantId() {
      return sessionStorage.getItem("tenantId");
    },
    isDarkTheme() {
      return customFunctions.getContrast(this.headerColor);
    },
    textColorStyle() {
      return this.isDarkTheme ? "color:white" : "color:#424242";
    },
    meetingTypeId() {
      return this.meetingFormData.meetingType.id;
    },
    isRecurrenceMeeting() {
      return !!this.meetingFormData.recurrenceId;
    },
  },
  methods: {
    onClose,
    getTimeDetails,
    ...mapActions({
      deleteMeetingData: "meeting/deleteMeeting",
      deleteMeetingSeries: "meeting/deleteMeetingSeries",
    }),
    onDeleteMeeting,
    deleteMeeting,
    onEditMeeting,
    onCopyMeeting,
    closeMeetingDialog,
    openMeetingDayPage,
    meetingPermission,
    onEditSelection,
    onDeleteSelection,
    getResolutionType(type) {
      if (type) {
        let resType = this.resolutionTypes.filter((obj) => obj.value === type);
        return resType.length > 0 ? resType[0].label : type;
      }
    },
  },
};

function onEditSelection(action) {
  this.isSeriesEdit = action;
  // this.dialogMeeting = true;
  this.onClose();
  this.$emit("editSelection", action);
}

function onDeleteSelection(action) {
  this.isSeriesDelete = action;
  this.onDeleteMeeting(this.meetingFormData);
}

function meetingPermission(permission) {
  return this.meetingTypeId
    ? this.$security.checkMeetingTypeAccess(this.meetingTypeId, permission)
    : false;
}

function onEditMeeting() {
  this.$emit("editSelection", false);
  // this.dialogMeeting = true;
  this.onClose();
}

function onCopyMeeting() {
  this.$emit("copyMeeting", false);
  this.onClose();
}

async function onDeleteMeeting(data) {
  const deleteType = this.isSeriesDelete
    ? this.$t("lblSeries")
    : this.$t("lblOccurrence");
  const confirmed = await this.$refs.confirm.open(
    this.$t("lblDeleteConfirmation"),
    this.$t("msgConfirmDeletion", {
      deleteType,
    })
  );

  if (confirmed) {
    await this.deleteMeeting(data);
  }
}

async function deleteMeeting(data) {
  let loader;
  try {
    loader = this.$localLoader.show();
    this.onClose();
    this.isSeriesDelete
      ? await this.deleteMeetingSeries(data.id)
      : await this.deleteMeetingData(data.id);
    this.$localLoader.hide(loader);
    this.$root.$emit("onDeleteMeeting", data);
  } catch (e) {}
}

function closeMeetingDialog() {
  this.dialogMeeting = false;
}

function openMeetingDayPage(id) {
  const { tenantId } = this;
  this.$router.push(`/meeting/${id}/calendar/tenant/${tenantId}`);
}

function onClose() {
  this.$emit("input", false);
}

function formatDateTime(dateTime, options) {
  return this.intl.formatDate(dateTime, options);
}

function getTimeDetails(data) {
  const startTime = formatDateTime.call(this, data.StartTime, {
    type: "date",
    skeleton: "long",
  });
  const endTime = formatDateTime.call(this, data.EndTime, {
    type: "date",
    skeleton: "long",
  });

  const startTimeFormatted = formatDateTime.call(this, data.StartTime, {
    skeleton: "hm",
  });
  const endTimeFormatted = formatDateTime.call(this, data.EndTime, {
    skeleton: "hm",
  });

  return `${startTime} ${startTimeFormatted} - ${endTime} ${endTimeFormatted}`;
}
</script>

<style scoped>
.tipMeetingName {
  overflow-wrap: break-word;
}
</style>